
import * as Vue from "vue";

export default Vue.defineComponent({
  props: ['isComingSoon']
});
